import { render, staticRenderFns } from "./ConsignmentManagement.vue?vue&type=template&id=2b0cee74"
import script from "./ConsignmentManagement.vue?vue&type=script&lang=js"
export * from "./ConsignmentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports